module.exports = __webpack_public_path__ + "img/2.845fdd50.jpg";